module.exports = __webpack_public_path__ + "static/media/Avatars_Female-21.7b5b044b.png";